import { graphql } from "react-relay";

export const fragments = {
  org: graphql`
    fragment ProfileTimeVisualizations_org on Org
    @argumentDefinitions(
      calendarId: { type: "String!" }
      timeZone: { type: "String!" }
      rangeMin: { type: "DayTimeSlotInput!" }
      rangeMax: { type: "DayTimeSlotInput!" }
    ) {
      calendarTimeStats(
        calendarId: $calendarId
        timeZone: $timeZone
        rangeMin: $rangeMin
        rangeMax: $rangeMax
      ) {
        calendarId
        focusMinutes
        busyMinutes
        fragmentedMinutes
        unclassifiedMinutes
        totalMinutes
        scoresByDay {
          calendarId
          secondaryKey
          busyMinutes
          focusMinutes
          totalMinutes
        }
      }
      userWorkingHours {
        workingHours {
          daySettings {
            day
          }
        }
      }
    }
  `,
};
